import React, { useEffect, useState } from "react";
import useApi from "../../helpers/apiHelper/requestHelper";
import { useNavigate } from "react-router-dom";
import Table from "../sharedPages/CommonComponents/Table";

const mapCommunitiesToTableData = (apiResponse) => {
  return apiResponse.map((item) => {
    const stats = item.stats?.[0] || {};
    const totalReviews = item.totalReviews || 0;
    const ratingValue = `${item?.averageRating}/5`;
    const ratingSmall =
      totalReviews > 0
        ? `(${totalReviews} Review${totalReviews > 1 ? "s" : ""})`
        : "(No Reviews)";

    const pnlValue = stats.pnl || 0;
    const winRateValue = stats.winRate || 0;

    return {
      ...item,
      name: { value: item.name, className: "clickAbleText" },
      rating: ratingValue,
      ratingSmall: ratingSmall,
      pnl: {
        value: `${pnlValue}%`,
        className: pnlValue > 0 ? "greenText" : pnlValue < 0 ? "redText" : "",
      },
      winRate: {
        value: `${winRateValue}%`,
        className:
          winRateValue > 0 ? "greenText" : winRateValue < 0 ? "redText" : "",
      },
      aum: {
        value: `$${item.AUM || 0}`,
        className: item.AUM > 0 ? "greenText" : item.AUM < 0 ? "redText" : "",
      },
      members: item.participants?.length?.toString() || "0",
      isActive: item.isActive ? "Active" : "In Active",
    };
  });
};

function CommunitiesListining() {
  const navigate = useNavigate();

  const api = useApi();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const getAllCommunities = async () => {
    const response = await api("post", "authorizeSuperAdmin/allCommunities");
    const data = mapCommunitiesToTableData(response?.data?.communities || []);
    setData(data);
  };

  useEffect(() => {
    getAllCommunities();
  }, []);

  const columns = [
    {
      label: "Group Name",
      key: "name",
      width: "25%",
      type: "profile",
      onClick: (row) => {
        navigate(`/superadmin/community/${row?._id}`);
      },
    },
    { label: "Rating", key: "rating", keySmall: "ratingSmall", width: "15%" },
    { label: "Active", key: "isActive", width: "12%" },
    { label: "PNL (YTD)", key: "pnl", width: "12%" },
    { label: "Win Rate", key: "winRate", width: "12%" },
    { label: "AUM", key: "aum", width: "12%" },
    { label: "Members", key: "members", width: "12%" },
  ];

  return (
    <div className="AccountSettingPage">
      <Table
        columns={columns}
        data={paginatedData}
        currentPage={currentPage}
        totalPages={Math.ceil(data.length / itemsPerPage)}
        onPageChange={setCurrentPage}
      />
    </div>
  );
}

export default CommunitiesListining;
